import React from 'react';
import RestaurantCatering from './RestaurantCatering';

const NewRestaurantCatering = () => {
  return <RestaurantCatering />;
};

export default NewRestaurantCatering;




